import FAQSchema from './schemas/faq.json';
import IndexSchema from './schemas/home.json';
import { Bundle, Item } from 'types';

const schemas: any = [
  {
    pathname: '/',
    schema: IndexSchema,
  },
  {
    pathname: '/support/faq',
    schema: FAQSchema,
  },
];

export const getPageSchema = (pathname: string) => {
  return schemas.find((p: any) => p.pathname === pathname)?.schema ?? null;
};

export const JsonLdScript = (schema: DynamicObject) => `<script type="application/ld+json">${JSON.stringify(schema)}</script>`;

const isBundle = (b: any): b is Bundle => ['suit', 'tuxedo'].includes(b.type);

const getItemImages = (item: Item): string[] => [
  `${item.media?.find((m) => m.label?.toLowerCase() === 'pdp_hero')?.url}?fm=jpg&fit=${
    isBundle(item) ? 'crop' : 'max'
  }&w=400&ar=5:7&auto=format`,
];

export const getItemPageSchema = async (item: Item, url: string) => {
  try {
    const itemPageSchema: DynamicObject = {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: item.display_name,
      image: getItemImages(item),
      description: item.short_description,
      brand: { '@type': 'Brand', name: 'Menguin' },
      offers: {
        '@type': 'Offer',
        url: `${process.env.NEXT_PUBLIC_LOCAL_URL}${url}`,
        priceCurrency: 'USD',
        price: item.cost,
        availability: 'https://schema.org/InStock',
        shippingDetails: {
          '@type': 'OfferShippingDetails',
          shippingDestination: {
            '@type': 'DefinedRegion',
            addressCountry: 'US',
          },
          hasMerchantReturnPolicy: {
            '@type': 'MerchantReturnPolicy',
            name: 'Menguin Rental Return Policy',
            description:
              'Return your rental within 3 days of your event via UPS or mail. Returns are free. A $25/day late fee applies for late returns.',
            returnPolicyCategory: 'https://schema.org/MerchantReturnFiniteReturnWindow',
            merchantReturnDays: 3,
            returnMethod: 'https://schema.org/ReturnByMail',
            returnFees: 'https://schema.org/FreeReturn',
          },
        },
      },
    };

    if (isBundle(item) && item.productReviews?.reviews.length) {
      itemPageSchema.aggregateRating = {
        '@type': 'AggregateRating',
        ratingValue: item.productReviews.bottomLine.averageScore.toFixed(2),
        ratingCount: item.productReviews.bottomLine.totalReview.toString(),
      };
    }
    return itemPageSchema;
  } catch (e) {
    throw new Error(`Error retrieving item page schema: ${e}`);
  }
};
